import request from '@/utils/request'
const BASE_URL = '/Dp'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  treeList(data) {
    return request({
      url: BASE_URL + '/TreeList',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  parentList(data) {
    return request({
      url: BASE_URL + '/ParentList',
      method: 'post',
      data
    })
  },
}